import { View } from "react-native";
import React from "react";

export const Spacer = ()=><View style={{ height: 21 }} />